// extracted by mini-css-extract-plugin
module.exports = {"unit":"var(--ring-unit)","header":"IndexHeader__header--n7","heading":"IndexHeader__heading--Fc","actions":"IndexHeader__actions--BT","title":"IndexHeader__title--lD"};